/// <amd-module name="VSS/Redux/Modules/ContentViewObserver/ContentViewObserverContracts" />
import { IFilter, IFilterState } from "VSSUI/Utilities/Filter";
import { IObservableValue } from "VSS/Core/Observable";

export interface IContentViewAwareState {
    contentViewObserver: IContentViewObserverState;
}

export interface IContentViewObserverState {
    selectedPivot: string;
    filterDetails?: IFilterDetails;
}

export interface IFilterDetails {
    projectId: string;
    filterKey: string;
    filterState: IFilterState;
    filterVisible: boolean;
}

export interface IFilterArgs {
    filter: IFilter;
    filterToggled: IObservableValue<boolean>;
}

export interface IContentViewObserverModuleArgs {
    filterArgs?: IFilterArgs;
    selectedTab?: IObservableValue<string>;
}
